import Views from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import { rosterEntriesIsComplete } from './LeftNavValidation';

const getRosterEntries = (viewName, route, omeMeetOrgUnitEntryInfoStateObjData) => {
  const isCurrent = viewName === Views.OME_MEET_ROSTER_ENTRIES;

  const arePrerequisitesDone = true;

  const isComplete = rosterEntriesIsComplete(omeMeetOrgUnitEntryInfoStateObjData) === true;

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_ROSTER_ENTRIES) : getInitialStateMeetRoute(Views.OME_MEET_ROSTER_ENTRIES);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getRosterEntries;